import { render, staticRenderFns } from "./profile-view-export.vue?vue&type=template&id=6b2bdc09"
import script from "./profile-view-export.vue?vue&type=script&lang=js"
export * from "./profile-view-export.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports